import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation, useQueryClient } from 'react-query';

import { contractConstants, contractModels } from '..';

export const useOnlineContractSave = () => {
  const qc = useQueryClient();

  return useMutation<
    { data: contractModels.IOnlineContractClientSignatureId },
    any,
    { contractId: number; lang: string }
  >(
    async data => {
      const res = await $api.post(stringifyUrl({ url: '/v1/online-contract', query: data }));

      return res?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([contractConstants.queryKeys.ONLINE_CONTRACT_CLIENT_SIGNATURE]);
      }
    }
  );
};
